/**
 * @generated SignedSource<<1c6f77e9e91de533804b57fb866feb50>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WACategoryTodoCategorySelectTypeComponent_widget$data = {
  readonly category: {
    readonly id: string;
    readonly isDefault: boolean;
    readonly title: string;
  };
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewPreview_widget">;
  readonly " $fragmentType": "WACategoryTodoCategorySelectTypeComponent_widget";
};
export type WACategoryTodoCategorySelectTypeComponent_widget$key = {
  readonly " $data"?: WACategoryTodoCategorySelectTypeComponent_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"WACategoryTodoCategorySelectTypeComponent_widget">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WACategoryTodoCategorySelectTypeComponent_widget",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetTodoOverviewPreview_widget"
    },
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      "action": "THROW"
    }
  ],
  "type": "WidgetTodoOverview",
  "abstractKey": null
};
})();

(node as any).hash = "3272207d67d794bc5a7e71dce92397c1";

export default node;
